export enum ListType {
  Carrier = 0,
  BookingProvider = 1,
  TripPaymentCard = 2,
  ImsSupplier = 3
}
